import type { BADGE_FALLBACK } from '@uefadigital/panenka';

import type { PlayerHistorical, PlayerResponse } from './types';

import type { EditorialContent } from '@cobalt/utilities';

export const getMatchIdsForUNL = () => ['2035581', '2035582', '2035583', '2035584'];

export const getPlayerIdByArray = (arr: PlayerResponse[]) => arr.map((p) => p.player.id);

export const getEditorialInfo = (editorialInfo: EditorialContent[], playerId: string) =>
  editorialInfo && editorialInfo.filter((e) => e.relations.find((r) => r.player && r.player.playerId === playerId));

export const getVideosFromEditorial = (editorialArray: EditorialContent[]) =>
  editorialArray.filter((e) => e.type === 'videostory');

export const getPhotosFromEditorial = (editorialArray: EditorialContent[]) =>
  editorialArray.filter((e) => e.type === 'photostory');

export const getPlayerInfoFromId = (arr: PlayerResponse[], id: string) => arr.find((obj) => obj.player.id === id);

const getImage = (arr: EditorialContent[]) => arr[0].imageUrl;

export const getArrPhotos = (player: PlayerResponse, editorialInfo: EditorialContent[]) => {
  const editorial = editorialInfo && getEditorialInfo(editorialInfo, player.player.id);
  const arrPhotos = editorial && getPhotosFromEditorial(editorial);
  if (Array.isArray(arrPhotos) && arrPhotos.length) {
    return arrPhotos;
  }
};

export const getArrVideos = (player: PlayerResponse, editorialInfo: EditorialContent[]) => {
  const editorial = editorialInfo && getEditorialInfo(editorialInfo, player.player.id);
  const arrVideos = editorial && getVideosFromEditorial(editorial);
  if (Array.isArray(arrVideos) && arrVideos.length) {
    return arrVideos;
  }
};

export const getKind = (player: PlayerResponse, editorialInfo: EditorialContent[]) => {
  const arrVideos = getArrVideos(player, editorialInfo);
  const arrPhotos = getArrPhotos(player, editorialInfo);
  if (arrVideos) {
    return 'video';
  } else if (arrPhotos) {
    return 'photo';
  }
  return 'placeholder';
};

export const getImageUrl = (player: PlayerResponse, editorialInfo: EditorialContent[]) => {
  const arrVideos = getArrVideos(player, editorialInfo);
  const arrPhotos = getArrPhotos(player, editorialInfo);
  if (arrVideos) {
    return getImage(arrVideos);
  } else if (arrPhotos) {
    return getImage(arrPhotos);
  }
};

export const getImageData = (player: PlayerResponse, editorialInfo: EditorialContent[]) => {
  const arrVideos = getArrVideos(player, editorialInfo);
  const arrPhotos = getArrPhotos(player, editorialInfo);
  if (arrVideos) {
    return arrVideos[0].mainMedia?.image;
  } else if (arrPhotos) {
    return arrPhotos[0].mainMedia?.image;
  }
};

export const getGoalCoordinates = (goalData: any[]) =>
  Array.isArray(goalData) && goalData.map((elm: any) => elm.fieldPosition?.coordinate);

export const getStatisticsData = (playerData: PlayerResponse) => {
  const arrayType = [
    'attempts',
    'attempts_on_target',
    'attempts_off_target',
    'attempts_on_woodwork',
    'attempts_blocked',
  ];
  const statisticsData = [];
  playerData &&
    playerData.statistics &&
    arrayType.forEach((type) => {
      const elm = playerData.statistics.find((x) => x.name === type);
      elm && statisticsData.push(elm.value);
    });
  return statisticsData;
};

export const getDataByName = (playerData: PlayerResponse, name: string, prop = 'value') => {
  const data: Record<string, string> = {};
  if (playerData && playerData.statistics) {
    const elm = playerData.statistics.find((x) => x.name === name);
    if (elm) data[name] = elm[prop];
  }
  return data;
};

export const getStatByName = (playerData: PlayerResponse, name: string) => {
  const value = playerData?.statistics?.find((x) => x.name === name)?.value;
  return value ? +value : -1;
};

export const getHowScoredData = (playerData: PlayerResponse) => {
  const arrayType = ['goals_scored_with_left', 'goals_scored_with_right', 'goals_scored_head', 'goals_scored_other'];
  const statisticsData = [];
  playerData &&
    playerData.statistics &&
    arrayType.forEach((type) => {
      const elm = playerData.statistics.find((x) => x.name === type);
      elm && statisticsData.push(elm.value);
    });
  return statisticsData;
};

export const getPlayerName = (player: PlayerHistorical, lang: string) =>
  lang === 'ru' ? player.translations.name.RU : player.translations.name.EN;

export const getFallBackImage = (player: any, options: any): BADGE_FALLBACK => {
  if (options?.cup === '2014' || (options?.cup === '18' && options?.phase === 'PREQUALIFYING')) {
    return 'unl-generic-badge';
  }
  return player?.team?.typeIsNational ? 'ntc-generic-badge-01' : 'club-generic-badge';
};

export const getLogoImage = (playerData: any, options: any) => {
  if (options?.cup === '2014' || (options?.cup === '18' && options?.phase === 'PREQUALIFYING')) {
    return `${window.imgBaseUrl}/imgml/flags/unl/${playerData?.team?.countryCode}.png`;
  }
  return playerData?.team?.logoUrl;
};
